import React from 'react';

const MAX_LENGTH = 35;
const SUFFIX_LENGTH = 10;

export default function (href: string, text: string, key: React.Key) {
  let linkText = text;
  let cleanText = text;
  let validHref = href;

  const regResult = /\[([\w\W]+)]\s*\(([\w\\/.,%&#?=:-]+)\)/.exec(text);
  if (regResult) {
    cleanText = regResult?.[1];
    validHref = regResult?.[2].includes('http')
      ? regResult[2]
      : 'http://'.concat(regResult[2]);
  }

  // eslint-disable-next-line react/destructuring-assignment
  if (text.length > MAX_LENGTH) {
    const prefixLength = MAX_LENGTH - SUFFIX_LENGTH - 3;
    // eslint-disable-next-line react/destructuring-assignment
    const prefix = text.substring(0, prefixLength);
    // eslint-disable-next-line react/destructuring-assignment
    const suffix = text.substring(text.length - SUFFIX_LENGTH, text.length);
    linkText = `${prefix}...${suffix}`;
  }

  return (
    <a href={(validHref) || href} key={key} target="_blank" rel="noopener noreferrer">
      {cleanText || linkText}
    </a>
  );
}
